import { generate as uuidv4 } from "short-uuid";
import { ADD_TENDER_CHAT } from "@Store/Actions/Customers/tenders";
export default (state = [], action) => {
    if (action.type === ADD_TENDER_CHAT) {
        const uid = uuidv4();
        return [{ uid, ...action.data }, ...state];
    }
    return state;
};
